<template>
    <v-bottom-sheet
        v-model="dialogShown"
        persistent
        scrollable
        :fullscreen="$vuetify.breakpoint.mobile"
        :inset="!$isSmallDesktop()"
        class="flex flex-direction: column;"
        :class="{smallDisplay: $isSmallDesktop()}"
        content-class="slotmanagement_bottomSheet">
        <v-card ref="card">
            <!-- >>> Selected Flight List -->
            <sdr-selected-flight-list
                :flights="flights"
                :selectedLayer="selectedLayer"
                :modus="modus"
                :smallScreen="$isSmallDesktop()" />
            <!-- <<< Selected Flight List -->
            <v-card-title class="mb-5 mt-7" style="width:100%;font-size:1.3rem;">
                Slot Request
            </v-card-title>
                <v-card-text class="mt-3" style="height:800px;width:100%;">
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container style="max-width:100vw">
                            <v-expansion-panels class="elevation-1">
                                <v-expansion-panel
                                    v-for="(request, i) in slotRequests"
                                    :key="i"
                                    class="pa-3 elevation-1"
                                    :class="request.airport.aptCode"
                                    @click="onClick_expansionPandel(request)">
                                    <v-expansion-panel-header>
                                        {{ request.airport.aptCode }}
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div style="width:100%;display:flex;justify-content:center;">
                                            <tiptap
                                                v-model="input_slotRequestText"
                                                class="slotrequest_tiptap"
                                                style="max-height:500px;overflow:scroll;height:400px;width:700px;border:1px solid #DDD"
                                                :disabled-extensions="[
                                                    'Bold',
                                                    'Underline',
                                                    'xl',
                                                    'Color',
                                                    'BulletList',
                                                    'Blockquote',
                                                    'Heading3',
                                                    'Heading1',
                                                    'Heading2',
                                                    'Table'
                                                ]" />
                                        </div>

                                        <v-card-actions>
                                            <v-switch
                                                v-model="input_deleteSlots"
                                                label="Delete selected Slots"
                                                @change="onChange_deleteSlots" />
                                            <v-switch
                                                v-model="input_setSlotStatus"
                                                label="Set Slot Status to 'Requested'"
                                                class="ml-3" />
                                        <v-spacer />
                                        <div>1.)</div>
                                        <v-btn
                                            text
                                            color="primary"
                                            style="padding:0 !important;margin"
                                            @click="onClick_copySlotRequest(currentAirport)">
                                            Copy
                                        </v-btn>
                                        /
                                        <v-btn
                                            text
                                            color="primary"
                                            style="padding:0 !important"
                                            @click="onClick_sendSlotRequest(currentAirport)">
                                            Open Email
                                        </v-btn>
                                        <!-- <div style="margin:0 19px;">
                                        2.)
                                        </div>
                                        <v-btn
                                            text
                                            color="primary"
                                            style="padding:0 19px!important"
                                            @click="onClick_updateFlights(currentAirport)">
                                            Update Slot Status
                                        </v-btn> -->
                                        </v-card-actions>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <!-- <div style="font-size:1rem;margin-left:8px;color:#3c4858">(OPEN/PENDING/GRANTED/EDITED - slot status)</div> -->
                    <div style="font-size:1rem;margin-left:8px;color:#3c4858">
                        *(EDITED / SLOTS)
                    </div>
                    <v-spacer />
                    <!-- <v-btn outlined color="#ab3b7a" >Close</v-btn> -->
                    <v-btn color="primary" @click="onClick_CloseSheet">
                        Close
                    </v-btn>
                </v-card-actions>
        </v-card>
    </v-bottom-sheet>
</template>

<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../../../main';
    import dayjs from 'dayjs';
    import isBetween from 'dayjs/plugin/isBetween';
    import SelectedFlightList from './SelectedFlightList.vue';

    import Tiptap from '../../../../../components/core/Editor.vue';

    dayjs.extend(isBetween);

    export default {
        name: 'SlotRequestDialog',

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-selected-flight-list': SelectedFlightList,
            Tiptap

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Props */
        props: {

            value: [Boolean],   // 'showSheet' itself
            modus: String,      // 'flight', 'slot', 'flightSlot'
            flights: Array,
            selectedLayer: Number,      // 1 Chain, 2 Rotation, 3 Leg
            smallScreen: Boolean

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function () {

            return {
                // >>> ------------------------------------ 'Form Validation Rules'
                valid: false,
                // >>> ------------------------------------ 'Slot Request'
                slotRequestOutput: '',
                input_slotRequestText: '',
                slotRequests: [],
                dataTable_selected: [],
                input_deleteSlots: false,
                currentAirport: null,
                currentRequest: null,
                // >>> Dialog "Set Slot Status to 'Requested'"
                input_setSlotStatus: true,
                selectedSlots: []
            };

        }, // eo funtion data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_AircraftConfigs',
                'get_Airports',
                'get_Flights_Filtered',
                'get_FlightTable_SelectedFlights',
                'get_SlotsTable_getSlots'
            ]),


            /*******************************************************************
            * dialogShown{}
            *
            * Desc:
            * Note:
            *
            */
            dialogShown: {

                get() {
                    const me = this;


                    me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> computed/dialogShown/get');
                    return me.value;

                }, // eo function sheetShown get()


                set(value) {

                    const me = this;


                    me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> computed/dialogShown/set');

                    if (typeof value === 'boolean') {
                        this.$emit('input', value);
                    }


                } // eo function sheetShown set()

            } // eo function dialogShown()

        }, // eo function created{}
        /* <<< ****************************************************************/

        /* >>> *************************************************************** / /* watch */
        watch: {}, // eo watch{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            const me = this;


            me.$toc('>>> vviews/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> created');
            eventBus.$on('rotationSelected', me.modus !== 'slot' ? me.onEmit_rotationSelected : me.onEmit_rotationSelectedSlot);

        }, // eo watch{}
        /* <<< ****************************************************************/

        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightsList.vue >>> destroyed');
            eventBus.$off('rotationSelected', me.modus !== 'slot' ? me.onEmit_rotationSelected : me.onEmit_rotationSelectedSlot);

        }, // eo function destroyed()
        /* <<< ****************************************************************/

        /* >>> *************************************************************** / /* methods */
        methods: {

            ...mapActions([
                'actn_call_slotmanagement_updateFlights',
                'actn_call_slotmanagement_createUpdateSlots'
            ]),
            /****************************************************************

            /*******************************************************************
            * onClick_CloseSheet
            *
            * Desc:
            * Note:
            *
            */
            onClick_CloseSheet: function() {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> onClick_CloseSheet');
                this.$emit('input', false);

            }, // eo function onClick_CloseSheet()

            /*******************************************************************
            * onEmit_rotationSelected
            *
            * Desc: Gets emitted from flight selection (SelectedFlightList.vue)
            * Desc: Groups Airports and Slots together
            * Note: selectedChildren contains a part of a rotation or a full rotation (depending on selection at SelectedFlightList.vue)
            * Note: Value gives us the build Object from SelectedFlightList.vue (watch > selectedFlights)
            * Note: more details about this object in SelectedFlightList.vue Line 124
            *
            */
            onEmit_rotationSelected: function (value) {

                const me = this,
                    airportsWithSlots = [],
                    selectedFlights = [];
                let foundAirport = null,
                    foundRotationSlot = null;

                /*******************************************************************
                * helper_findRotationSlot
                *
                * Desc: Helper function to dig into deep nested Slots
                * Note: We need to find the Slots of the Rotation instead of
                * Note: the Slots from Single Leg (which are given from selectedChildren)
                * Note: This is because the Slots of the Rotation give us essential information
                * Note: about VIA / TRIA relationships between legs
                *
                */
                function helper_findSlotsOfRotation(rotationSlots, legSlot) {
                    for (const rotationSlot of rotationSlots) {
                        if (rotationSlot.idFlight === legSlot.idFlight && rotationSlot.direction === legSlot.direction) {
                            return rotationSlot;
                        }
                        if (rotationSlot.slots) {
                            const innerResult = helper_findSlotsOfRotation(rotationSlot.slots, legSlot);
                            if (innerResult) {
                                return innerResult;
                            }
                        }
                    }
                };  // eo function helper_findRotationSlot()

                /*******************************************************************
                * helper_groupSlotRequests
                *
                * Desc: Helper function to group equal Slot Requests
                * Note:
                *
                *
                */
                function helper_groupSlotRequests(slots) {

                    const me = this,
                        groupedSlotRequets = [];
                    let readyToGroup,
                        beginningOfSlotPeriod = null;

                    slots.forEach((slot, i) => {
                        readyToGroup = undefined;
                        beginningOfSlotPeriod = beginningOfSlotPeriod || slot.legs[0].date;
                        // first check - same amount of legs?
                        if (slots[i + 1] && slot.legs.length === slots[i + 1].legs.length) {
                            // second check - all slot relevant values equal?
                            slot.legs.forEach((leg, j) => {
                                if (leg.aircraft.capacityY === slots[i + 1].legs[j].aircraft.capacityY &&
                                    leg.airport === slots[i + 1].legs[j].airport &&
                                    leg.viaAirport === slots[i + 1].legs[j].viaAirport &&
                                    leg.direction === slots[i + 1].legs[j].direction &&
                                    leg.flightModus === slots[i + 1].legs[j].flightModus &&
                                    leg.flightNo === slots[i + 1].legs[j].flightNo &&
                                    leg.scheduledTime === slots[i + 1].legs[j].scheduledTime &&
                                    leg.slotTime === slots[i + 1].legs[j].slotTime) {
                                    // all values equal - slot is part of the period so keep on looking to 'close' chain
                                    readyToGroup = false;
                                } else {
                                    // at least one value not equal - slot isn't part of the period anymore
                                    readyToGroup = true;
                                }
                            });
                        } else {
                            // different amount of legs can't get grouped
                            readyToGroup = true;
                        }
                        // change startDate and endDate but keep all other values for grouped slot request
                        if (readyToGroup) {
                             slot.legs.forEach(leg => {
                                leg.startDate = beginningOfSlotPeriod;
                                leg.endDate = leg.date;
                            });
                            groupedSlotRequets.push(slot);
                            beginningOfSlotPeriod = null; // reset
                        };
                    });

                    return groupedSlotRequets;
                }; // eo function helper_groupSlotRequests()

                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> onEmit_rotationSelected');
                value.sort((a, b) => new Date(a.date) - new Date(b.date)).forEach(flights => {
                    flights.selectedChildren.forEach(selectedChild => {
                        selectedFlights.push(selectedChild.leg);
                    });
                });
                me.selectedFlights = selectedFlights;
                value.forEach(rotation => {
                    // selectedChildren could contain single legs and/or whole rotation (depending on user selection)
                    rotation.selectedChildren.forEach(selectedChild => {
                        selectedChild.slotRequestLeg.forEach((leg, id) => {
                            // group slots for each airport
                            foundAirport = airportsWithSlots.find(airport => airport.airport.aptCode === leg.airport.aptCode);
                            if (foundAirport) {
                                // regroup single slots from rotation
                                foundRotationSlot = foundAirport.slots.find(slot => slot.id === rotation.id);
                                if (foundRotationSlot) {
                                    foundRotationSlot.legs.push(
                                        helper_findSlotsOfRotation(rotation.slotRequestsRotation, leg.slots[0]) // leg.slots is always an Array with only 1 entry
                                    );
                                } else {
                                    foundAirport.slots.push({
                                        id: rotation.id,
                                        legs: [
                                            helper_findSlotsOfRotation(rotation.slotRequestsRotation, leg.slots[0]) // leg.slots is always an Array with only 1 entry
                                        ],
                                        internationalFormat: leg.airport.details.idCountry !== 70
                                    });
                                }
                            } else if (leg.airport.coordinated) {
                                airportsWithSlots.push({
                                    id: rotation.id,
                                    airport: leg.airport,
                                    slots: [{
                                        id: rotation.id,
                                        legs: [
                                            helper_findSlotsOfRotation(rotation.slotRequestsRotation, leg.slots[0]) // leg.slots is always an Array with only 1 entry
                                        ],
                                        internationalFormat: leg.airport.details.idCountry !== 70
                                    }]
                                });
                            }
                        });
                    });
                });

                airportsWithSlots.forEach(airportWithSlots => {
                    airportWithSlots.slots = helper_groupSlotRequests(airportWithSlots.slots);
                });
                me.slotRequests = airportsWithSlots;

                // Changes if function onEmit_rotationSelected gets emitted (if a flight gets selected)
                // Refrehes the tiptap field with new slot requests based on selected flights
                if (me.slotRequests.length > 0 && me.currentAirport) {
                    me.slotRequestOutput = 'tiptap';
                    me.currentRequest = me.slotRequests.find(v => v.airport.aptCode === me.currentAirport.aptCode);
                    me.input_slotRequestText = me.buildSlotRequestText(me.currentRequest);
                }

            }, // eo function onEmit_rotationSelected()

            /*******************************************************************
            * onEmit_rotationSelectedSlot
            *
            * Desc: Gets emitted from flight selection (SelectedFlightList.vue)
            * Desc: Groups Airports and Slots together
            * Note: selectedChildren contains a part of a rotation or a full rotation (depending on user selection at SelectedFlightList.vue)
            * Note: Value gives us the build Object from SelectedFlightList.vue (watch >>> selectedFlights)
            * Note: more details about this object in SelectedFlightList.vue Line 124
            *
            */
            onEmit_rotationSelectedSlot: function (value) {

                const me = this,
                    selectedSlots = [],
                    airportsWithSlots = [],
                    dayOfWeek = [
                        ' 0000007',
                        ' 1000000',
                        ' 0200000',
                        ' 0030000',
                        ' 0004000',
                        ' 0000500',
                        ' 0000060'
                    ];
                let foundAirport = null;


                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> onEmit_rotationSelectedSlot');

                /*******************************************************************
                * helper_groupSlotRequests
                *
                * Desc: Helper function to group equal Slot Requests
                * Note:
                *
                *
                */
                function helper_groupSlotRequests(slots) {

                    const me = this,
                        groupedSlotRequets = [];
                    let readyToGroup,
                        beginningOfSlotPeriod = null;

                    slots.forEach((slot, i) => {

                        readyToGroup = undefined;
                        beginningOfSlotPeriod = beginningOfSlotPeriod || slot.legs[0].date;
                        // first check - same amount of legs?
                        if (slots[i + 1] && slot.legs.length === slots[i + 1].legs.length) {
                            // second check - all slot relevant values equal?

                            slot.legs.forEach((leg, j) => {
                                if (leg.aircraftType.capacityY === slots[i + 1].legs[j].aircraftType.capacityY &&
                                    leg.airport === slots[i + 1].legs[j].airport &&
                                    leg.viaAirport === slots[i + 1].legs[j].viaAirport &&
                                    leg.direction === slots[i + 1].legs[j].direction &&
                                    leg.flightType === slots[i + 1].legs[j].flightType &&
                                    leg.flightNo === slots[i + 1].legs[j].flightNo &&
                                    JSON.stringify(leg.slotChangeLogs) === JSON.stringify(slots[i + 1].legs[j].slotChangeLogs) &&
                                    dayjs(leg.slotTime).format('HH:mm') === dayjs(slots[i + 1].legs[j].slotTime).format('HH:mm')) {
                                    // all values equal - slot is part of the period so keep on looking to 'close' chain
                                    readyToGroup = false;
                                } else {
                                    // at least one value not equal - slot isn't part of the period anymore
                                    readyToGroup = true;
                                }
                            });
                        } else {
                            // different amount of legs can't get grouped
                            readyToGroup = true;
                        }
                        // change startDate and endDate but keep all other values for grouped slot request
                        if (readyToGroup) {
                            slot.legs.forEach(leg => {
                                slot.startDate = beginningOfSlotPeriod;
                                slot.endDate = leg.date;
                                slot.dateRange = dayjs(beginningOfSlotPeriod).format('DDMMM') === dayjs(leg.date).format('DDMMM')
                                    ? dayjs(beginningOfSlotPeriod).format('DDMMM ')
                                    : dayjs(beginningOfSlotPeriod).format('DDMMM') + dayjs(leg.date).format('DDMMM ');
                                slot.dayOfWeek = dayOfWeek[dayjs(beginningOfSlotPeriod).format('d')] + ' ';
                            });
                            groupedSlotRequets.push(slot);
                            beginningOfSlotPeriod = null; // reset
                        };
                    });

                    return groupedSlotRequets;
                }; // eo function helper_findRotationSlot()

                // group equal airports and create slot request for each given selectedChildren (leg)
                value.forEach(slot => {
                    selectedSlots.push(slot);
                    foundAirport = airportsWithSlots.find(airport => airport.airport.aptCode === slot.airportSlot.aptCode);

                    if (foundAirport) {
                        foundAirport.slots.push({
                            legs: slot.selectedChildren,
                            // slotRequest: helper_createSlotRequest(slot.selectedChildren),
                            slotTime: slot.slotTime
                        });
                    } else {
                        airportsWithSlots.push({
                            id: slot.id,
                            airport: slot.airportSlot,
                            slots: [{
                                legs: slot.selectedChildren, // if selectedChildren.length === 1 it's a single leg; if selectedChildren.length === 2 it's a rotation
                                // slotRequest: helper_createSlotRequest(slot.selectedChildren),
                                slotTime: slot.slotTime
                            }]
                        });
                    }
                });

                airportsWithSlots.forEach(airportWithSlots => {
                    airportWithSlots.slots = helper_groupSlotRequests(airportWithSlots.slots);
                });
                me.slotRequests = airportsWithSlots;
                me.selectedSlots = selectedSlots;
                // Changes if function onEmit_rotationSelected gets emitted (if a flight gets selected)
                // Refrehes the tiptap field with new slot requests based on selected flights
                if (me.slotRequests.length > 0 && me.currentAirport) {
                    me.slotRequestOutput = 'tiptap';
                    me.currentRequest = me.slotRequests.find(v => v.airport.aptCode === me.currentAirport.aptCode);
                    me.input_slotRequestText = me.buildSlotRequestText(me.currentRequest);
                }
            }, // eof onEmit_rotationSelectedSlot

            /*******************************************************************
            * onClick_expansionPandel
            *
            * Desc: Dialog to show all detected Airports/Flights with Slot relevant issues
            * Note:
            *
            */
            onClick_expansionPandel: function(request) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> onClick_expansionPandel');
                me.input_deleteSlots = false;
                me.currentAirport = request.airport;
                me.currentRequest = request;
                me.slotRequestOutput = 'tiptap';
                me.input_slotRequestText = me.buildSlotRequestText(request);

            }, // eo function onClick_expansionPandel()

            /*******************************************************************
            * buildSlotRequestText
            *
            * Desc: Builds the slot request
            * Note: TODO: sort Requests (date)
            *
            */
            buildSlotRequestText: function(request) {

                const me = this;

                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> buildSlotRequestText');
                if (me.modus !== 'slot') {
                    return  me.buildSlotRequestText_header(request) +
                            me.buildSlotRequestText_body(request) +
                            me.buildSlotRequestText_footer();
                } else {
                    return me.buildSlotRequestText_header(request) +
                           me.buildSlotRequestText_body_slot(request) +
                           me.buildSlotRequestText_footer();
                }

            }, // eo function buildSlotRequestText()

            /*******************************************************************
            * buildSlotRequestText_header
            *
            * Desc: Text Module Header Slot Message
            * Note:
            *
            */
            buildSlotRequestText_header: function(request) {

                const me = this;
                const slotRequestHeaderModules = {};

                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> buildSlotRequestText_header');
                slotRequestHeaderModules.coordinationLevel = request.airport.coordinationLevel === 'LEVEL2' ? 'SMA' : 'SCR';
                slotRequestHeaderModules.sender = '/SCHEDULING@SUNDAIR.COM';
                slotRequestHeaderModules.appliedSeason = me.helper_buildSlotRequestText_currentSeason(request);
                slotRequestHeaderModules.currentDate = dayjs().format('DDMMM').toUpperCase();
                slotRequestHeaderModules.airport = request.airport.aptCode;
                return me.helper_buildSlotRequestText_text('header', slotRequestHeaderModules);

            }, // eo function buildSlotRequestText_header()

            /*******************************************************************
            * buildSlotRequestText_body
            *
            * Desc: Text Module Delete Slot
            * Note: 3 possible methods -> DELETE SLOT / NEW SLOT (only flight) / CHANGE REQUEST SLOT
            * TODO: CLEAN UP as follows!!!!
            *
            * for (const slot of request.slots) {
            const { legs, internationalFormat } = slot;
            let slotTypes;

            switch (legs.length) {
                case 1:
                if (me.input_deleteSlots) {
                    slotTypes = ['D'];
                } else if (legs[0].slotTime === undefined) {
                    slotTypes = ['N'];
                } else {
                    slotTypes = ['C', 'R'];
                }
                break;

                case 2:
                if (me.input_deleteSlots) {
                    slotTypes = ['D'];
                } else if (legs.every(leg => leg.slotTime === undefined)) {
                    slotTypes = ['N'];
                } else if (legs[0].slotTime !== undefined && legs[1].slotTime === undefined) {
                    slotTypes = [['C', 'R'], ['N']];
                } else if (legs[0].slotTime === undefined && legs[1].slotTime !== undefined) {
                    slotTypes = [['N'], ['C', 'R']];
                } else {
                    slotTypes = ['C', 'R'];
                }
                break;
            }
                buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage(legs, slotTypes, internationalFormat);
            }
            */
            buildSlotRequestText_body: function(request) {

                const me = this;
                let buildSlotRequestTextBodyText = '';


                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> buildSlotRequestText_body');
                request.slots.forEach(slot => {
                    if (slot.legs.length === 1) {
                        // DELETE SLOTS
                        if (me.input_deleteSlots) {

                            buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage(slot.legs, ['D'], slot.internationalFormat);
                            // CREATE NEW SLOT
                        } else if (!slot.legs[0].slotTime) {

                            buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage(slot.legs, ['N'], slot.internationalFormat);

                            // CHANGE REQUEST
                        }  else if (slot.legs[0].slotTime) {

                            buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage(slot.legs, ['C', 'R'], slot.internationalFormat);

                        }
                    } else if (slot.legs.length === 2) {
                        // DELETE SLOTS
                        if (me.input_deleteSlots) {

                            buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage(slot.legs, ['D'], slot.internationalFormat);

                            // CREATE NEW SLOT FOR BOTH LEGS
                        } else if (!slot.legs[0].slotTime && !slot.legs[1].slotTime) {

                            buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage(slot.legs, ['N'], slot.internationalFormat);

                            // CHANGE REQUEST FOR FIRST LEG AND CREATE NEW SLOT FOR SECOND LEGS
                        } else if (slot.legs[0].slotTime && !slot.legs[1].slotTime) {

                            buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage([slot.legs[0]], ['C', 'R'], slot.internationalFormat);
                            buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage([slot.legs[1]], ['N'], slot.internationalFormat);

                            // CREATE NEW SLOT FOR FIRST LEGS AND CHANGE REQUEST FOR SECOND LEG
                        } else if (!slot.legs[0].slotTime && slot.legs[1].slotTime) {

                            buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage([slot.legs[0]], ['N'], slot.internationalFormat);
                            buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage([slot.legs[1]], ['C', 'R'], slot.internationalFormat);

                            // CHANGE REQUEST SLOT FOR (BOTH) LEGS
                        } else if (slot.legs[0].slotTime && slot.legs[1].slotTime) {

                            buildSlotRequestTextBodyText += me.buildSlotRequestText_body_slotMessage(slot.legs, ['C', 'R'], slot.internationalFormat);

                        }
                    }
                });

                return buildSlotRequestTextBodyText;

            }, // eo function buildSlotRequestText_body()

            /*******************************************************************
            * buildSlotRequestText_body_slotMessage
            *
            * Desc: Second Parameter
            * Note: TODO: CLEAN UP!
            *
            * @param {object} item ('slot from')
            * @param {string} slotRequestMethod ('Slot Request Method')
            */
            buildSlotRequestText_body_slotMessage: function(legs, slotRequestMethods, internationalFormat) {

                const me = this,
                    slotRequestBodyModules = {},
                    dayOfWeek = [
                        ' 0000007',
                        ' 1000000',
                        ' 0200000',
                        ' 0030000',
                        ' 0004000',
                        ' 0000500',
                        ' 0000060'
                    ];
                let date = null,
                    isSameDate = false,
                    slotRequestBody = '',
                    slotRequestBody2 = '';
                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> buildSlotRequestText_body');
                slotRequestMethods.forEach((slotRequestMethod, index1) => {
                    legs.forEach((leg, index2) => {
                        date = (slotRequestMethod === 'N' || slotRequestMethod === 'R') ? leg.scheduledTime : leg.slotTime;
                        isSameDate = dayjs(leg.startDate).isSame(dayjs(leg.endDate), 'date');
                        if (!leg.slotTime && me.input_deleteSlots) {
                            return;
                        }
                        if (legs.length > 1 && internationalFormat) {
                            if (index2 === 0) {
                                slotRequestBodyModules.slotRequestMethod = slotRequestMethod;
                                // slotRequestBodyModules.departureSpace = legs[0].direction === 'DEPARTURE' ? ' ' : '';
                                slotRequestBodyModules.flightNumber = leg.flightNo + ' ';
                                slotRequestBodyModules.date = dayjs(leg.startDate).utc().format('DDMMM').toUpperCase();
                                slotRequestBodyModules.dayOfWeek = dayOfWeek[dayjs(leg.date).utc().format('d')] + ' ';
                                slotRequestBodyModules.aircraftType = String(leg.aircraft.capacityY === 144 ? 150 : leg.aircraft.capacityY) + String(leg.aircraft.capacityY > 150 ? 320 : 319) + ' ';
                                slotRequestBodyModules.timeAndAirport = leg.airport + leg.viaAirport + date + ' ';
                                slotRequestBodyModules.flightType = leg.flightModus;
                            } else if (index2 === 1) {
                                slotRequestBodyModules.flightNumber += leg.flightNo + ' ';
                                slotRequestBodyModules.date += dayjs(leg.endDate).utc().format('DDMMM').toUpperCase();
                                slotRequestBodyModules.timeAndAirport += date + leg.airport + leg.viaAirport + ' ';
                                slotRequestBodyModules.flightType += leg.flightModus;

                                slotRequestBody += me.helper_buildSlotRequestText_text('body', slotRequestBodyModules);
                            }

                        } else {
                            slotRequestBodyModules.slotRequestMethod = slotRequestMethod;
                            slotRequestBodyModules.departureSpace = leg.direction === 'DEPARTURE' ? ' ' : '';
                            slotRequestBodyModules.flightNumber = leg.flightNo + ' ';
                            slotRequestBodyModules.date = `${dayjs(leg.startDate).utc().format('DDMMM').toUpperCase()}${!isSameDate || internationalFormat ? dayjs(leg.endDate).utc().format('DDMMM').toUpperCase() : ''}`;
                            slotRequestBodyModules.dayOfWeek = `${!isSameDate || internationalFormat ? dayOfWeek[dayjs(leg.date).utc().format('d')] : ''} `;
                            slotRequestBodyModules.aircraftType = String(leg.aircraft.capacityY === 144 ? 150 : leg.aircraft.capacityY) + String(leg.aircraft.capacityY > 150 ? 320 : 319) + ' ';
                            slotRequestBodyModules.timeAndAirport = leg.direction === 'DEPARTURE' ? date + leg.airport + leg.viaAirport + ' ' : leg.viaAirport + leg.airport + date + ' ';
                            slotRequestBodyModules.flightType = leg.flightModus;

                            if (index1 === 0 && index2 === 0) {
                                slotRequestBody += me.helper_buildSlotRequestText_text('body', slotRequestBodyModules);
                            }
                            if (index1 === 0 && index2 === 1) {
                                slotRequestBody2 += me.helper_buildSlotRequestText_text('body', slotRequestBodyModules);
                            }
                            if (index1 === 1 && index2 === 0) {
                                slotRequestBody += me.helper_buildSlotRequestText_text('body', slotRequestBodyModules);
                            }
                            if (index1 === 1 && index2 === 1) {
                                slotRequestBody2 += me.helper_buildSlotRequestText_text('body', slotRequestBodyModules);
                            }
                        }
                    });
                });

                return slotRequestBody + slotRequestBody2;

            }, // eo function buildSlotRequestText_body_slotMessage()

            /*******************************************************************
            * buildSlotRequestText_body_slot
            *
            * Desc: Second Parameter
            * Note:
            *
            * @param {object} request ('slot')
            */
            buildSlotRequestText_body_slot: function (request) {

                const me = this;
                let slotMessage = '';

                function helper_createSlotRequest(slots) {
                    const slotRequests = [],
                        firstRequestLine = {},
                        secondRequestLine = {},
                        firstRequestLine2 = {},
                        secondRequestLine2 = {},
                        slotRequestMethods = {
                            CHANGE: 'C',
                            DELETE: 'D'
                        };

                    slots.forEach((slot, index) => {
                        if (!firstRequestLine.slotRequestMethod || slot.airportSlot.idCountry !== 70) {
                            // first leg request 'C', 'D'
                            // can contain 2 rows (C , R) or just 1 row (D)
                            const currentLeg = index === 0 ? 'firstLeg' : 'secondLeg';
                            firstRequestLine.slotRequestMethod = me.input_deleteSlots || slot.status === 'DELETE' ? 'D' : 'C';
                            firstRequestLine.departureIndicator = slot.airportSlot.idCountry === 70 && slot.direction === 'DEPARTURE' ? ' ' : '';
                            firstRequestLine.flightNo = currentLeg === 'firstLeg' ? slot.flightNo + ' ' : `${firstRequestLine.flightNo} ${slot.flightNo}` + ' ';
                            firstRequestLine.aircraft = String(slot.aircraftType.capacityY === 144 ? 150 : slot.aircraftType.capacityY) + String(slot.aircraftType.capacityY > 150 ? 320 : 319) + ' '; // keeps the same
                            firstRequestLine.slot = currentLeg === 'firstLeg' ? slot.slot + ' ' : `${firstRequestLine.slot} ${slot.slot} `;
                            firstRequestLine.mainServiceType = currentLeg === 'firstLeg' ? slot.mainServiceType : `${firstRequestLine.mainServiceType}${slot.mainServiceType}`;
                            if (firstRequestLine.slotRequestMethod === 'C') {
                                // R request
                                firstRequestLine2.slotRequestMethod = 'R';
                                firstRequestLine2.departureIndicator = slot.airportSlot.idCountry === 70 && slot.direction === 'DEPARTURE' ? ' ' : '';
                                firstRequestLine2.flightNo = slot.changedFlightNo[0] ? currentLeg === 'firstLeg' ? slot.changedFlightNo[0] + ' ' : `${firstRequestLine2.flightNo} ${slot.changedFlightNo[0]} ` : firstRequestLine.flightNo + ' ';
                                firstRequestLine2.aircraft = slot.changedAircraft ? String(slot.changedAircraft.capacityY === 144 ? 150 : slot.changedAircraft.capacityY) + String(slot.changedAircraft.capacityY > 150 ? 320 : 319) + ' ' : firstRequestLine.aircraft + ' ';
                                firstRequestLine2.slot = slot.changedSlot[0] ? currentLeg === 'firstLeg' ? slot.changedSlot[0] + ' ' : `${firstRequestLine2.slot} ${slot.changedSlot[0]} ` : firstRequestLine.slot + ' ';
                                firstRequestLine2.mainServiceType = currentLeg === 'firstLeg' ? slot.mainServiceType : `${firstRequestLine2.mainServiceType}${slot.mainServiceType}`;
                            }
                            // only push when German format or last slot in array
                            if (slot.airportSlot.idCountry === 70 || index === slots.length - 1) {
                                const payload = [firstRequestLine];
                                if (Object.keys(firstRequestLine2).length > 0) {
                                    payload.push(firstRequestLine2);
                                }
                                slotRequests.push(payload);
                            }
                        } else {
                            // second leg request 'C', 'D' usally for German Slot Request Format
                            secondRequestLine.slotRequestMethod = me.input_deleteSlots || slot.status === 'DELETE' ? 'D' : 'C';
                            secondRequestLine.departureIndicator = slot.airportSlot.idCountry === 70 && slot.direction === 'DEPARTURE' ? ' ' : '';
                            secondRequestLine.flightNo = slot.flightNo + ' ';
                            secondRequestLine.aircraft = String(slot.aircraftType.capacityY === 144 ? 150 : slot.aircraftType.capacityY) + String(slot.aircraftType.capacityY > 150 ? 320 : 319) + ' ';
                            secondRequestLine.slot = slot.slot + ' ';
                            secondRequestLine.mainServiceType = slot.mainServiceType;
                            if (secondRequestLine.slotRequestMethod === 'C') {
                                // R request
                                secondRequestLine2.slotRequestMethod = 'R';
                                secondRequestLine2.departureIndicator = slot.airportSlot.idCountry === 70 && slot.direction === 'DEPARTURE' ? ' ' : '';
                                secondRequestLine2.flightNo = slot.changedFlightNo[0] ? slot.changedFlightNo[0] + ' ' : slot.flightNo + ' ';
                                secondRequestLine2.aircraft = slot.changedAircraft ? String(slot.changedAircraft.capacityY === 144 ? 150 : slot.changedAircraft.capacityY) + String(slot.changedAircraft.capacityY > 150 ? 320 : 319) + ' ' : firstRequestLine.aircraft + ' ';
                                secondRequestLine2.slot = slot.changedSlot[0] ? slot.changedSlot[0] + ' ' : slot.slot + ' ';
                                secondRequestLine2.mainServiceType = slot.mainServiceType;
                            }
                            const payload = [secondRequestLine];
                            if (Object.keys(secondRequestLine2).length > 0) {
                                payload.push(secondRequestLine2);
                            }
                            slotRequests.push(payload);
                        }
                    });
                    return slotRequests;
                }

                request.slots.forEach(slot => {
                    helper_createSlotRequest(slot.legs).forEach(requests => {
                        requests.forEach(request => {
                            const slotRequestBodyModules = {};
                            slotRequestBodyModules.slotRequestMethod = request.slotRequestMethod;
                            slotRequestBodyModules.departureIndicator = request.departureIndicator;
                            slotRequestBodyModules.flightNumber = request.flightNo;
                            slotRequestBodyModules.dateRange = slot.dateRange.toUpperCase();
                            slotRequestBodyModules.dayOfWeek = [...slot.dateRange].length > 6 ? slot.dayOfWeek : ''; // > 6 means we have a date range from to so we have to show the week of day
                            slotRequestBodyModules.aircraft = request.aircraft;
                            slotRequestBodyModules.slot = request.slot;
                            slotRequestBodyModules.mainServiceType = request.mainServiceType;
                            slotMessage += me.helper_buildSlotRequestText_text('body', slotRequestBodyModules);
                        });

                    });
                });

                return slotMessage;

            }, // eo function buildSlotRequestText_body_slot()

            /*******************************************************************
            * buildSlotRequestText_footer
            *
            * Desc: Text Module Footer Slot Message
            * Note:
            *
            */
            buildSlotRequestText_footer: function() {

                const me = this;
                let slotRequestFooterText = '';

                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> buildSlotRequestText_footer');
                slotRequestFooterText = 'GI KIND REGARDS SUNDAIR';

                return slotRequestFooterText;

            }, // eo function buildSlotRequestText_footer()

            /*******************************************************************
            * helper_buildSlotRequestText_currentSeason
            *
            * Desc: Text Module Delete Slot
            * Note:
            *
            */
            helper_buildSlotRequestText_currentSeason: function(request) {

                const me = this,
                      date = request.slots[0].legs[0].date;
                let departureTime = '',
                    departureYear = '',
                    startSommerTime = '',
                    startWinterTime = '',
                    currentSeason = '',
                    currentYear = '';


                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> helper_buildSlotRequestText_currentSeason');
                departureTime = date;
                departureYear = dayjs(date).year();
                startSommerTime = dayjs().date(27).month(2).year(departureYear);
                startWinterTime = dayjs().date(30).month(9).year(departureYear);

                if (dayjs(departureTime).isBetween(startSommerTime, startWinterTime, 'day', '[]')) {

                    currentSeason = 'S';
                } else {

                    currentSeason = 'W';
                }
                currentYear = dayjs().year(departureYear).format('YY');

                return currentSeason + currentYear;


            }, // eo function helper_buildSlotRequestText_currentSeason()

            /*******************************************************************
            * helper_buildSlotRequestText_text
            *
            * Desc: Text Module Delete Slot
            * Note:
            *
            */
            helper_buildSlotRequestText_text: function(slotRequestPart, textModules) {

                const me = this;
                let text = '';



                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> helper_buildSlotRequestText_text');
                if (slotRequestPart === 'header') {

                    Object.entries(textModules).forEach(([key, module]) => {
                        if (me.slotRequestOutput === 'tiptap') {

                            text += '<div>' + module + '</div>';
                        } else {

                            text += module + '%0D%0A';
                        }
                    });
                }

                if (slotRequestPart === 'body') {

                    Object.entries(textModules).forEach(([key, module], i) => {

                        if (me.slotRequestOutput === 'tiptap') {

                            if (i === 0) {

                                text = '<div>' + module;

                            } else if (i + 1 === Object.keys(textModules).length) {

                                text += module + '</div>';

                            } else {

                                text += module;
                            }
                        } else {

                            if (i + 1 === Object.keys(textModules).length) {

                                text += module + '%0D%0A';

                            } else {

                                text += module;

                            }
                        }
                    });
                }

                return text;

            }, // eo function helper_buildSlotRequestText_text

            /*******************************************************************
            * buildEmailSubject
            *
            * Desc: Created the email subject based on the request
            * Note:
            *
            * @param {object} request ('request with all slots and legs')
            */
            buildEmailSubject: function(request) {

                const me = this;
                let subject = '',
                    coordinationLevel = '',
                    airportCode = '',
                    startDate = '',
                    endDate = '',
                    lastSlot = {},
                    lastLeg = {};

                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> buildEmailSubject');
                coordinationLevel = request.airport.coordinationLevel === 'LEVEL2' ? 'SMA' : 'SCR';
                airportCode = request.airport.aptCode;
                startDate = dayjs(request.slots[0].legs[0].startDate).utc().format('DDMMM').toUpperCase();
                lastSlot = request.slots[request.slots.length - 1];
                lastLeg = lastSlot.legs[lastSlot.legs.length - 1];
                endDate = dayjs(lastLeg.endDate).utc().format('DDMMM').toUpperCase();

                subject = `${coordinationLevel} ${airportCode} ${startDate}${endDate}`;

                return subject;

            }, // eo function buildEmailSubject()

            /*******************************************************************
            * onClick_sendSlotRequest
            *
            * Desc: Sends the Slot Request to the designated email
            * Note:
            *
            */
            onClick_sendSlotRequest: function(airport) {

                const me = this;
                let emailContacts = '';


                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> onClick_sendSlotRequest');
                if (airport.details.slotContacts.length > 0) {
                    airport.details.slotContacts.forEach(s => {
                        emailContacts += s.email + ';';
                    });
                }
                me.slotRequestOutput = 'email';
                window.location.href = `mailto:${emailContacts}?subject=${me.buildEmailSubject(me.currentRequest)}&body=${me.buildSlotRequestText(me.currentRequest)}`;
                if (me.input_setSlotStatus) {
                    me.modus !== 'slot' ? me.onClick_updateFlights(airport) : me.onClick_updateSlots();
                }

            }, // eo function onClick_sendSlotRequest()

            /*******************************************************************
            * onClick_copySlotRequest
            *
            * Desc: Copies the Slot Request to the clip board
            * Note:
            *
            */
            onClick_copySlotRequest: function(airport) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> onClick_copySlotRequest');
                const element = document.getElementsByClassName('ProseMirror');

                navigator.clipboard.writeText(element[0].innerText.replace(/\n\n/g, '\n'));
                Vue.prototype.$toasted.global.sdr_app_info({
                    message: 'Slot Request copied'
                });
                if (me.input_setSlotStatus) {
                    me.modus !== 'slot' ? me.onClick_updateFlights(airport) : me.onClick_updateSlots();
                }

            }, // eo function onClick_copySlotRequest()

            /*******************************************************************
            * onClick_updateFlights
            *
            * Desc: Update the slot status based on currently selected airport
            * Note:
            *
            */
            onClick_updateFlights: function(airport) {

                const me = this,
                    flights = [];

                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> onClick_updateFlights');
                me.selectedFlights.forEach(flight => {
                    if (flight.aptFrom.aptCode === airport.aptCode) {
                        flight.depSlotStatus = 'pending';
                    } else if (flight.aptTo.aptCode === airport.aptCode) {
                        flight.arrSlotStatus = 'pending';
                    }
                    flights.push(Vue.prototype.$buildFlightUpdatePayload(flight));
                });
                me.actn_call_slotmanagement_updateFlights({ flights: flights });

            }, // eo function onClick_updateFlights()

            /*******************************************************************
            * onClick_updateSlots
            *
            * Desc: Update the slot status based on currently selected airport
            * Note:
            *
            */
            onClick_updateSlots: function(airport) {

                const me = this,
                    slotIds = [],
                    payload = [];

                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> onClick_updateSlots');
                me.selectedSlots.forEach(rotation => {
                    rotation.selectedChildren.forEach(selectedChild => {
                        selectedChild.slotChangeLogs.forEach(slotChangeLog => {
                            slotChangeLog.slotIds.forEach(slotId => {
                                slotIds.push(slotId);
                            });
                        });
                    });
                });
                me.get_SlotsTable_getSlots.filter(slot => slotIds.includes(slot.id)).forEach(slot => {
                    slot.status = 'PENDING';
                    payload.push(Vue.prototype.$buildSlotUpdatePayload(slot));
                });

                me.actn_call_slotmanagement_createUpdateSlots({ loadingMask: true, payload: { slots: payload } });

            }, // eo function onClick_updateSlots()

            /*******************************************************************
            * onChange_deleteSlots
            *
            * Desc:
            * Note:
            *
            */
            onChange_deleteSlots: function() {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/shared/SlotRequestDialog.vue >>> onChange_deleteSlots');
                me.slotRequestOutput = 'tiptap';
                me.input_slotRequestText = me.buildSlotRequestText(me.currentRequest);

            } // eo function onChange_deleteSlots()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style scoped>

    .flightsTable_slotsStatus {
		width:95px;
		justify-content:center;
	}

    .test p{

        margin-bottom: 0px !important;
    }
    .rowWasEdited {
		/* border-left: 4px solid #AB3B7C;
		padding-left: 4px; */
		/* background-color: #AB3B7C; */
		border: 2px solid #AB3B7C;
		padding: 2px;

	}
</style>
